
import Swal from 'sweetalert2';
import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import axios from "axios";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";

const base_url = process.env.REACT_APP_API_URL;





const BetSportsMatch = () => {
    const navigate=useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [permit, setPermit] = useState([]);
  const { getRoles } = useContext(AuthContext);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState({});
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Search term

  const handleSelection = (matchId, team) => {
    setSelectedTeams((prev) => ({ ...prev, [matchId]: team }));
  };

  
const handleConfirmAndSubmit = (match) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to declare the result for this match?  Winner : ${selectedTeams[match.id]} `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, declare it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        submitMatchData(match); // your original function
      }
    });
  }

  const submitMatchData = async (match) => {
    const selectedTeam = selectedTeams[match.id] || null;
    if (!selectedTeam) {
      toast.error("Please select a team before submitting!");
      return;
    }
    try {
      await axios.post(`${base_url}/api/webapi/admin/updateResult`, {
        matchId: match.id,
        selectedTeam,
      });
      toast.success("Match result updated successfully!");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error updating match result:", error);
      toast.error("Failed to update match result!");
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);
      roles.map((role) => {
        const values = Object.values(role);
        values[0].map((val) => {
          if (Object.keys(val).includes("matches")) {
            const permit = Object.values(val);
            setPermit(permit[0]);
          }
        });
      });
    } catch (error) {
      console.log("ert", error);
    }
  };

  const GetMyMatches = async (Type) => {
    // console.log("Fetching matches...");
    // console.log("Type is", Type);
    setLoading(true);
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(
        `${base_url}/api/webapi/admin/getBetMatch`,
        {
          params: { Type },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      const data = response?.data.data;
      setMatches(data || []);
    } catch (error) {
      console.error("Error fetching matches:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchRoles();
    GetMyMatches("Cricket");
  }, []);

  const filteredMatches = matches.filter((match) =>
    match.eventname?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="wrapper">
      <AdminSidebar isSidebarOpen={isSidebarOpen} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

      <div className={`content-wrapper ${isSidebarOpen ? "" : "open-content-wrapper"}`}>
        <div className="container-fluid">
          <h5 className="m-0">Results</h5>
        </div>

        <section className="content">
          <div className="mt-2 tophead d-flex justify-content-between">
            <div className="d-flex align-items-center cursor-pointer justify-content-center">
              <div className="top px-2">Betfair</div>
              <div className="top px-2">Casino</div>
            </div>
            <div className="d-flex gap-2 pb-1">
            <button
            onClick={ ()=> navigate("/admin/manage_market")}
                type="button"
                className={`btn btn-sm btn-primary px-3 py-1 `}
              >
               Back
              </button>
              <button
                type="button"
                className={`btn btn-sm btn-primary px-3 py-1 ${
                  permit.includes("Add Matches") ? "d-block" : "d-none"
                }`}
              >
                Add Manual Match
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary refreshButton px-3 py-1"
                onClick={() => window.location.reload()}
              >
                Refresh
              </button>
            </div>
          </div>

          <div id="myMatches" className="mt-2 tophead d-flex justify-content-between">
            <div className="d-flex align-items-center cursor-pointer">
              <div className="p-2 mid" onClick={() => GetMyMatches("Cricket")}>
                <img src="/assets/images/crickball1.png" height="20px" width="20px" alt="Cricket Ball" />
                Cricket
              </div>
              <div className="p-2 mid" onClick={() => GetMyMatches("Tennis")}>
                <img src="/assets/images/tennis1.png" height="20px" width="20px" alt="Tennis Ball" />
                Tennis
              </div>
              <div className="p-2 mid" onClick={() => GetMyMatches("Soccer")}>
                <img src="/assets/images/soccer1.png" height="19px" width="19px" alt="Soccer Ball" />
                Soccer
              </div>
            </div>

            {/* ✅ Search Input */}
            <div className="my-2 px-2 w-25">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search by match name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <table role="grid" className="table table-hover datatable table-striped mt-4">
              <thead className="bg-dark text-light">
                <tr>
                  <th>Sport Name</th>
                  <th>Competition Name</th>
                  <th>Market Name</th>
                  <th>Open Date</th>
                  <th>Choose Winner</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredMatches.length > 0 ? (
                  filteredMatches.map((match, index) => {
                    const eventParts = match.eventname
                      ? match.eventname.split(" v ")
                      : [];
                    return (
                      <tr key={index}>
                        <td>
                          <div>{match.sportname}</div>
                          <div className="text-bold">{match.eventname}</div>
                        </td>
                        <td>{match.competitionname}</td>
                        <td>{match.marketname}</td>
                        <td>{new Date(match.opendate).toISOString().replace("T", " ").replace("Z", "")}</td>

                        <td>
                          {eventParts.length === 2 ? (
                            <div
                              style={{
                                backgroundColor: "rgb(79 187 52)",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              <input
                                type="radio"
                                name={`event-${index}`}
                                value={eventParts[0]}
                                id={`team1-${index}`}
                                checked={selectedTeams[match.id] === eventParts[0]}
                                onChange={() => handleSelection(match.id, eventParts[0])}
                                disabled={match.update_status === 1}
                              />
                              <label htmlFor={`team1-${index}`} className="ms-1">
                                {eventParts[0]}
                              </label>
                              <input
                                type="radio"
                                name={`event-${index}`}
                                value={eventParts[1]}
                                id={`team2-${index}`}
                                className="ms-3"
                                checked={selectedTeams[match.id] === eventParts[1]}
                                onChange={() => handleSelection(match.id, eventParts[1])}
                                disabled={match.update_status === 1}
                              />
                              <label htmlFor={`team2-${index}`} className="ms-1">
                                {eventParts[1]}
                              </label>
                            </div>
                          ) : (
                            <div
                              style={{
                                backgroundColor: "rgb(79 187 52)",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              {match.eventname}
                            </div>
                          )}
                        </td>
                        <td>
                        <button
                        className="btn btn-warning btn-sm ms-2"
                        onClick={() => handleConfirmAndSubmit(match)}
                        disabled={match.update_status === 1}
                        >
                        Update
                        </button>

                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No matches available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <a id="back-to-tops" href="##" className="btn btn-primary back-to-top" role="button" aria-label="Scroll to top">
        <i className="fas fa-chevron-up" />
      </a>
    </div>
  );
};

export default BetSportsMatch;
